<script lang="ts">
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'

    import { signedIn } from 'hydria/services/session'
    import { spath } from 'hydria/svelte_helpers'

    import { default as SignedOut } from 'hydria/SignedOut/Index.svelte'
    import { default as SignedIn } from './SignedIn.svelte'

    let forceSignedOut = $state(false)
    if (window.location.pathname.startsWith(spath('/user-request/'))) {
        forceSignedOut = true
    }

    setContext('signed-in-context', writable('unknown'))
</script>

{#if !$signedIn || forceSignedOut}
    <SignedOut />
{:else}
    <SignedIn />
{/if}
